import { Component } from "react";
import * as React from "react";
import { fetchDeadByDaylightLeaderboard } from "../../services/ApiContext";
import PageContainer from "../../containers/PageContainer";
import Header from "../../components/Header/Header";
import Menu from "../../components/Menu/Menu";
import DeadByDaylight from "../../objects/DeadByDaylightInterface";
import { Link } from "react-router-dom";
import ContentLoading from "../../components/Others/ContentLoading";

class HalloweenLeaderboard extends Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			apiData: null
		};
	}

	public async componentDidMount() {
		const apiData = await fetchDeadByDaylightLeaderboard();
		this.setState({
			apiData: apiData
		});
	}

	public render() {
		if (this.state.apiData === null) {
			return (
				<PageContainer>
					<Header/>
					<main id="main-container">
						<Menu/>
						<div className="content content-full">
							<div
								className="col-xl-12 col-md-12 col-sm-12 text-xl-center text-md-center text-sm-center pt-lg-9 pb-lg-10">
								<ContentLoading/>
							</div>
						</div>
					</main>
				</PageContainer>
			);
		}
		return (
			<PageContainer>
				<Header/>
				<main id="main-container">
					<Menu/>
					<div className="content content-full">
						<h1>Dead By Daylight Minihra</h1>
						<div className="block block-rounded block-bordered">
							<div className="alert alert-info alert-dismissable" role="alert">
								<p className="mb-0">Pro zobrazení všech statistik z minihry, navštiv svůj profil!
								</p>
							</div>
							<div className="block-content block-content-full">
								<table className="table table-bordered table-striped table-vcenter js-dataTable-full">
									<thead>
									<tr>
										<th className="text-center" style={{width: '50px'}}>#</th>
										<th>Nick</th>
										<th className="text-center">Killer: výhry</th>
										<th className="text-center">Survivor: výhry</th>
										<th className="text-center">Odehráno her</th>
										<th className="text-center">K: Zabití</th>
										<th className="text-center">K: Smrt zásahů</th>
										<th className="text-center">S: Opraveno generátorů</th>
									</tr>
									</thead>
									<tbody>
									{this.generateTable()}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</main>
			</PageContainer>
		);
	}

	public generateTable() {
		const apiData = this.state.apiData as DeadByDaylight[];
		let finalTable: any = [];
		apiData.forEach((player: DeadByDaylight, index: number) => {
			if (index >= 150) { // Limit 150 jelikož jaksi to není v SQL requestu (FAIL)
				return;
			}
			finalTable.push(
				<tr>
					<td className="text-center">{index + 1}</td>
					<td><Link to={"/player/" + player.nick}>{player.nick}</Link></td>
					<td className="text-center">{player.killer_wins}</td>
					<td className="text-center">{player.survivor_wins}</td>
					<td className="text-center">{player.games_played}</td>
					<td className="text-center">{player.killer_kills}</td>
					<td className="text-center">{player.killer_downs}</td>
					<td className="text-center">{player.survivor_generators_powered}</td>
				</tr>
			);
		});
		return finalTable;
	}

}

export default HalloweenLeaderboard;
